import selectPhotos from "./selectPhotos";

Alpine.data('selectPhotos', selectPhotos);
